import * as SliderPrimitive from "@radix-ui/react-slider";

export const CONDITION_TEXT = {
  1: ["Needs significant work", "Major damage, mechanical faults, warning lights or not running."],
  3: ["Below average", "Noticeable dents, scratches or a worn interior. May need some repairs."],
  5: ["Average", "Normal wear for its age – a few minor marks, everything works."],
  7: ["Good", "Tidy bodywork and interior, well maintained, no known faults."],
  9: ["Excellent", "Exceptionally clean, no marks, full service history."],
};
export const conditionText = (n) => CONDITION_TEXT[n % 2 ? n : n - 1];

export const ConditionSlider = ({ value, onChange }) => {
  const [title, desc] = conditionText(value);
  return (
    <div className="space-y-3" data-testid="condition-field">
      <div className="flex flex-col gap-0.5 sm:flex-row sm:items-baseline sm:justify-between sm:gap-3">
        <label id="condition-label" className="block text-sm font-semibold text-slate-900">Overall condition</label>
        <span className="text-sm font-semibold text-brand-navy" data-testid="condition-value">{value}/10 · {title}</span>
      </div>
      <SliderPrimitive.Root min={1} max={10} step={1} value={[value]} onValueChange={([v]) => onChange(v)}
                            className="relative flex h-8 w-full touch-none select-none items-center" aria-labelledby="condition-label" data-testid="condition-slider">
        <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-slate-200">
          <SliderPrimitive.Range className="absolute h-full bg-primary" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb aria-label="Condition rating" className="block h-7 w-7 rounded-full border-2 border-primary bg-white shadow-md transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 active:scale-110" data-testid="condition-thumb" />
      </SliderPrimitive.Root>
      <div className="flex justify-between text-xs text-slate-500" aria-hidden><span>1 · Poor</span><span>10 · Excellent</span></div>
      <p className="text-sm text-slate-600" data-testid="condition-description">{desc}</p>
    </div>
  );
};
